module.exports = __webpack_public_path__ + "static/media/cov-19-notif.035a13ac.png";